import Image from 'next/image'

interface IProps {
  src: string
  alt: string
  width?: number | null
  height?: number | null
  className?: string
}

export const ImageComponent = ({ src, alt, width, height, className }: IProps) => {
  const ratio = width && height ? width / height : 1.5 
  const placeholderWidth = 602.42 // Desktop content section width
  const placeholderHeight = placeholderWidth / ratio

  // width and height can be set to any size should be defined outside of this class
  return (
      <Image
        className={`h-full w-full rounded-lg object-cover default-border ${className}`}
        src={src}
        alt={alt}
        width={placeholderWidth}
        height={placeholderHeight}
        sizes="
          (max-width: 640px) 100vw,
          (max-width: 1024px) 50vw, 
          25vw"
      />
  )
}

export default ImageComponent
